export const GET_BRANDS = "GET_BRANDS";
export const GET_SINGLE_BRAND = "GET_SINGLE_BRAND";
export const RESET_BRAND = "RESET_BRAND";
